@if (operand) {
  @if (isCustom) {
    <em-icon [name]="'auto_awesome'" class="text-primary-300 inline-block">
    </em-icon>
  } @else {
    @switch (operand.type) {
      @case ('attribute') {
        <em-icon
          [name]="'shopping_bag'"
          class="text-primary-300 inline-block"
        ></em-icon>
      }
      @case ('static_value') {
        @switch (operatorType) {
          @case ('integer') {
            <em-icon
              [name]="'tag'"
              class="text-primary-300 inline-block"
            ></em-icon>
          }
          @case ('date') {
            <em-icon
              [name]="'calendar_month'"
              class="text-primary-300 inline-block"
            ></em-icon>
          }
          @default {
            <em-icon
              [name]="'text_fields'"
              class="text-primary-300 inline-block"
            ></em-icon>
          }
        }
      }
      @default {}
    }
  }
}
